import {combineReducers} from "redux";
import {createPagedDataReducer, PagedDataState} from "../common/util/pagination/PaginationUtil";
import {actionTypes, IMPORTED_DATA_ACTION_TYPE_NAME} from "./actions";
import {ImportedData, ImportedDataSearchFilter, ApolloCatalogData} from "./model";
import {moduleName} from "./selectors";

type SearchDataTypes = { value: string, label: string }[];
type FilterState = ImportedDataSearchFilter;

interface ReactorUpdateState {
    numberOfNewDataItems: number;
    numberOfRemovedDataItems: number;
    numberOfNewFolders?: number;
    numberOfRemovedFolders?: number;
}

export interface ImportedDataState {
    filter: FilterState;
    allDataTypes: SearchDataTypes;
    reactorDataUpdates: ReactorUpdateState;
    pages: PagedDataState<ImportedData>;
    folders: ApolloCatalogData[];
}

const initialReactorUpdateState: ReactorUpdateState = {
    numberOfNewDataItems: 0,
    numberOfRemovedDataItems: 0,
    numberOfNewFolders: 0,
    numberOfRemovedFolders: 0
};

const reactorUpdateReducer = (state: ReactorUpdateState = initialReactorUpdateState, action) => {
    switch (action.type) {
        case actionTypes.DATA_ADDED_ON_SERVER:
            return Object.assign({}, state, {numberOfNewDataItems: state.numberOfNewDataItems + 1});
        case actionTypes.DATA_REMOVED_ON_SERVER:
            return Object.assign({}, state, {numberOfRemovedDataItems: state.numberOfRemovedDataItems + 1});
        case actionTypes.FOLDER_ADDED_ON_SERVER:
            return Object.assign({}, state, {numberOfNewFolders: state.numberOfNewFolders + 1});
        case actionTypes.FOLDER_REMOVED_ON_SERVER:
            return Object.assign({}, state, {numberOfRemovedFolders: state.numberOfRemovedFolders + 1});
        case actionTypes.CLEAR_DATA: //reset counter when we do a new request
            return Object.assign({}, state, initialReactorUpdateState);
        default:
            return state;
    }
};

const allDataTypeReducer = (state: SearchDataTypes = [], action) => {
    if (action.type === actionTypes.LOAD_DATA_TYPES) {
        return [...action.payload.dataTypes];
    } else {
        return state;
    }
};


const basePagedDataReducer = createPagedDataReducer<ImportedData>(IMPORTED_DATA_ACTION_TYPE_NAME);
const defaultState = basePagedDataReducer(undefined, {type: "init"});
//extend the existing pagedDataReducer so that it also handles UPDATE_DATA actions
const extendedPagedProductReducer = (state: PagedDataState<ImportedData> = defaultState, action) => {
    if (action.type === actionTypes.UPDATE_DATA) {
        const oldData = state.data;
        const newData = Object.assign({}, oldData, {[action.payload.data.id]: action.payload.data});
        return Object.assign({}, state, {data: newData});
    } else {
        return basePagedDataReducer(state, action);
    }
};

function filterReducer(state: FilterState = {}, action) {
    if (action.type === actionTypes.SET_DATA_FILTER) {
        return action.payload;
    }
    return state;
}

const foldersReducer = (state: ApolloCatalogData[] = [], action) => {
    if (action.type === actionTypes.LOAD_FOLDERS) {
        return [...action.payload.folders];
    } else {
        return state;
    }
};
const reducer = combineReducers<ImportedDataState>({
    filter: filterReducer,
    reactorDataUpdates: reactorUpdateReducer,
    allDataTypes: allDataTypeReducer,
    pages: extendedPagedProductReducer,
    folders: foldersReducer,
});

const createTestState = () => {
    return {
        [moduleName]: reducer(undefined, {type: "init"}),
    };
};

export {
    moduleName,
    reducer,
    createTestState,
};